export enum AdvancedImageBoxComponentViewEnum {
	SINGLE = 'single',
	TILES = 'tiles',
	SWIPER = 'swiper',
}
